<header class="dummy-header">
  <span class="asideInfoClose" (click)="infoAsideClose.emit()">
    <svg class="icon">
      <use xlink:href="#cross"></use>
    </svg>
  </span>
</header>
<img *ngIf="loan?.LoanOfficer?.profileImage else brokerSvg" class="broker-thumb" [src]="loan.LoanOfficer.profileImage">
<ng-template #brokerSvg>
  <svg class="icon fill-current broker-thumb">
    <use xlink:href="#user"></use>
  </svg>
</ng-template>

<div *ngFor="let contact of loanContacts; let first = first;">
  <h3 class="broker-name fs-unmask">{{contact.WizeUser?.name | empty}}</h3>
  <div *ngIf="contact.LoanRole"
       class="broker-designation fs-unmask">{{contact.WizeUser.jobTitle ? contact.WizeUser.jobTitle : contact.LoanRole}}</div>
  <p class="fs-unmask" *ngIf="contact.WizeUser?.email">{{contact.WizeUser.email}}</p>
  <p class="fs-unmask"
     *ngIf="contact.WizeUser?.phone">{{contact.WizeUser.phone | phone : contact.WizeUser.workPhoneExt}}</p>
  <p class="fs-unmask">NMLS {{contact.WizeUser?.nmlsId ? '#' + contact.WizeUser.nmlsId : '--'}}</p>
  <ul class="contact-broker" *ngIf="first">
    <li>
      <a class="fs-unmask" [href]="contact.WizeUser?.email ? 'mailto:' + contact.WizeUser.email: 'javascript:void(0)'" target="_blank">
        <svg class="icon icon-search-lens">
          <use xlink:href="#message-mail"></use>
        </svg>
        Email
      </a>
    </li>
    <li>
      <a class="fs-unmask" [href]="contact.WizeUser?.phone | phoneLink : contact.WizeUser.workPhoneExt">
        <svg class="icon icon-search-lens">
          <use xlink:href="#call2"></use>
        </svg>
        Call
      </a>
    </li>
  </ul>
  <hr>
</div>


<ng-container *ngIf="metaOrgUnit && loan.WizeOrgUnit">
  <p class="sub-detail fs-unmask">{{metaOrgUnit.WizeOrgDBAConfig?.displayName || metaOrgUnit.displayName}}</p>

  <div>
    <p class="fs-unmask" *ngIf="loan.WizeOrgUnit.streetAddress">{{loan.WizeOrgUnit.streetAddress}}</p>
    <p class="fs-unmask" *ngIf="loan.WizeOrgUnit.apt">{{loan.WizeOrgUnit.apt}}</p>
    <p
      class="fs-unmask">{{loan.WizeOrgUnit.city ? loan.WizeOrgUnit.city + ', ' : ''}}{{loan.WizeOrgUnit.state ? (loan.WizeOrgUnit.state + (loan.WizeOrgUnit.zipcode ? (' ' + loan.WizeOrgUnit.zipcode) : '') + ', ') : ''}}
      USA</p>
  </div>

  <div style="margin-top: 0.8rem">
    <p class="fs-unmask" *ngIf="loan.WizeOrgUnit.email">{{loan.WizeOrgUnit.email}}</p>
    <p class="fs-unmask" *ngIf="loan.WizeOrgUnit.phone">{{loan.WizeOrgUnit.phone | phone}}</p>
    <p class="fs-unmask">
      NMLS {{loan.WizeOrgUnit.Broker?.nmlsNumber ? '#' + loan.WizeOrgUnit.Broker.nmlsNumber : '--'}}</p>
  </div>
</ng-container>

<p *ngIf="metaOrgUnit?.complianceLogo" class="housing-logo">
  <img [src]="metaOrgUnit.complianceLogo">
</p>

<nav class="bottom-nav">
  <ul>
    <li
      *ngIf="metaOrgUnit?.Broker.nmlsNumber && (metaOrgUnit.Broker.nmlsNumber !== loan.WizeOrgUnit?.Broker?.nmlsNumber)">
      <a class="fs-unmask" href="javascript:">Company NMLS #{{metaOrgUnit.Broker.nmlsNumber}}</a>
    </li>
    <li><a class="fs-unmask" [href]="privacyPolicyUrl" target="_blank">Privacy Policy</a></li>
    <li><a class="fs-unmask" [href]="termsOfUseUrl" target="_blank">Term of Use</a></li>
  </ul>
</nav>

